import * as React from "react";
import { forwardRef } from "react";
const SvgSize = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 17, height: 17, viewBox: "0 0 17 17", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M10.0007 6.66536L15.834 0.832031M15.834 0.832031H10.834M15.834 0.832031V5.83203M6.66732 9.9987L0.833984 15.832M0.833984 15.832H5.83398M0.833984 15.832L0.833985 10.832", stroke: "#A4A7AE", strokeWidth: 1.66667, strokeLinecap: "round", strokeLinejoin: "round" }));
const ForwardRef = forwardRef(SvgSize);
export { ForwardRef as ReactComponent };
